import { LinkHighlightButton } from '../HighlightButton/HighlightButton';

const Page404 = () => {
  return (
    <main className="mainContainer centeredVertically">
      <div className="centeredHorizontallyOnMobile textCenteredOnMobile">

        <h1>Page not found</h1>
        <div style={{ width: 134 }}>
          <LinkHighlightButton to="/">
            RETURN HOME
          </LinkHighlightButton>
        </div>
      </div>
    </main>
  )
}

export default Page404;
